import { api } from "@/lib/api";

function urlBase64ToUint8Array(base64String) {
  const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, "+").replace(/_/g, "/");
  const rawData = atob(base64);
  const output = new Uint8Array(rawData.length);
  for (let i = 0; i < rawData.length; i++) output[i] = rawData.charCodeAt(i);
  return output;
}

export function isPushSupported() {
  return (
    typeof window !== "undefined" &&
    "serviceWorker" in navigator &&
    "PushManager" in window &&
    "Notification" in window
  );
}

let swRegPromise = null;
export function getSWRegistration() {
  if (!swRegPromise) {
    swRegPromise = navigator.serviceWorker.register("/sw.js", { scope: "/" });
  }
  return swRegPromise;
}

export async function getPushPermission() {
  if (!isPushSupported()) return "unsupported";
  return Notification.permission;
}

export async function subscribeToPush() {
  if (!isPushSupported()) throw new Error("Push not supported");
  const perm = await Notification.requestPermission();
  if (perm !== "granted") throw new Error("Permission denied");
  const reg = await getSWRegistration();
  const { data } = await api.get("/push/vapid-public-key");
  const publicKey = data.public_key;
  let sub = await reg.pushManager.getSubscription();
  if (!sub) {
    sub = await reg.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey: urlBase64ToUint8Array(publicKey),
    });
  }
  const json = sub.toJSON();
  await api.post("/push/subscribe", {
    endpoint: json.endpoint,
    keys: json.keys,
  });
  return sub;
}

export async function unsubscribeFromPush() {
  if (!isPushSupported()) return false;
  const reg = await getSWRegistration();
  const sub = await reg.pushManager.getSubscription();
  if (!sub) return false;
  try {
    await api.post("/push/unsubscribe", { endpoint: sub.endpoint });
  } catch {}
  return sub.unsubscribe();
}

export async function currentSubscription() {
  if (!isPushSupported()) return null;
  try {
    const reg = await getSWRegistration();
    return await reg.pushManager.getSubscription();
  } catch {
    return null;
  }
}
